var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{attrs:{"editorToolbar":_vm.toolbar,"placeholder":"Type here"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }